"use client";

import { TouchSwipeWrapper } from '@/components/utils/TouchSwipeWrapper';
import { useItineraryMapStore } from "@/core/stores/itinerary";
import { useItinerarySettingsStore } from '@/core/stores/itinerary/settings';
import useSizeController from '@/hooks/useSizeController';
import dynamic from 'next/dynamic';
import { ReactNode, useState } from "react";

const LimitedAccessModal = dynamic(() => import('./LimitedAccessModal'))
const Modal = dynamic(() => import('@/components/ui/Modal'))
const FiltersV2 = dynamic(() => import('@/components/FiltersV2'))

const PageWrapper = ({ children, }: { children: ReactNode, }) => {
  const { setShowHotelsFilters, showHotelsFilters,
    showAccessModal, setShowAccessModal } = useItineraryMapStore()

  const { setShowMap, showMap } = useItinerarySettingsStore()

  const { innerWidth, } = useSizeController()
  return (
    <TouchSwipeWrapper touchToLeft={() => setShowMap(true)}>
      <div className={`${showMap && innerWidth < 768 ? "-translate-x-full" : ""}
      absolute z-40 appHeight bg-rose-200 transition-transform duration-500 md:relative`}>

        <Modal
          maxWidth='max-w-lg'
          bgColor='bg-white'
          identifier='Filters'

          tabletHeight='!max-h-[50dvh]'
          onClose={() => {
            setShowHotelsFilters(false);

          }}
          title="Filters"
          show={showHotelsFilters}
        >
          <FiltersV2 >

          </FiltersV2>
        </Modal>

        <LimitedAccessModal baseAssetsApi='' isOpen={showAccessModal} onClose={() => setShowAccessModal(false)} />



        <div className="relative flex h-full w-screen md:w-full">
          <div
            className={`md:translate-x-0 absolute left-0 top-0 z-0 h-full max-h-full 
                          w-screen grow overflow-x-visible bg-white shadow-sidebar transition-transform   
                         duration-300 ease-out md:left-full md:w-[416px]`}
          >

            <div id='itinerary-page-wrapper' className="no-scroller h-full max-h-full  overflow-y-auto bg-gray-50">


              {children}
            </div>
          </div>
        </div>
      </div >
    </TouchSwipeWrapper>
  );
};

export default PageWrapper;

